import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { fetchParticipationRegisterOpen$, PARTICIPATION_REGISTER_CLOSED_FALLBACK } from './event-participation-register-open.utils';

/**
 * Hides guest registration pages when org registration deadline has passed (matches join_event).
 * Returns { visible, message? } for dynamic-form to show why the survey has no visible pages.
 */
export function event_register_deadline_visible(service: ComponentDataSourceService): DataSourceFunction {
  return {
    name: 'event_register_deadline_visible',
    description: 'Whether participation/register-open allows showing registration (deadline + active event). For visibilityDataSource.',
    execute: (params?: LoadDataParams): Observable<{ visible: boolean; message?: string }> => {
      return fetchParticipationRegisterOpen$(service, params).pipe(
        map(({ open, message }) => ({
          visible: open,
          ...(open ? {} : { message: message || PARTICIPATION_REGISTER_CLOSED_FALLBACK })
        }))
      );
    }
  };
}
